import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Box.module.scss';
import Toolbar from '../Toolbar';

export default function Box(props) {
  const { children, toolbar, title, className, wrap = true } = props;

  const hasToolbar = toolbar && toolbar !== '';
  const hasTitle = title && title !== '';

  return (
    <>
      {hasToolbar && <Toolbar name={toolbar} />}

      <div className={cn(styles.container, wrap ? '' : styles.noWrap, className)}>
        {hasTitle && <h3 className={styles.title}>{title}</h3>}

        <div className={styles.body}>{children}</div>
      </div>
    </>
  );
}

Box.propTypes = {
  title: PropTypes.string,
  toolbar: PropTypes.string,
  children: PropTypes.node.isRequired,
  wrap: PropTypes.bool,
  className: PropTypes.string,
};
